import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { validateSession } from "./authSlice";

const Redirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const reduxSessionId = useSelector((state) => state.auth.sessionId);

  useEffect(() => {
    const verifySession = async () => {
      // Allow access to public routes without sessionId
      if (location.pathname === "/" || location.pathname === "/login") {
        return;
      }

      const localSessionId = localStorage.getItem("sessionId");
      const localUser = localStorage.getItem("user");

      if (!localSessionId || !localUser) {
        // No session found, redirect to login unless already there
        if (location.pathname !== "/login") {
          navigate("/login", { replace: true });
        }
        return;
      }

      try {
        // Validate session data exists and is valid JSON
        JSON.parse(localUser);

        // Session appears valid, ensure Redux state is updated if needed
        if (!reduxSessionId) {
          dispatch(validateSession());
        }

        // If user is on login page with valid session, redirect to home
        if (location.pathname === "/login") {
          navigate("/home", { replace: true });
        }
      } catch (error) {
        // Invalid session data, clear localStorage and redirect to login
        localStorage.removeItem("sessionId");
        localStorage.removeItem("user");
        navigate("/login", { replace: true });
      }
    };

    verifySession();
  }, [navigate, location.pathname, dispatch, reduxSessionId]);

  return null;
};

export default Redirect;
